import { useCallback, useEffect, useState } from "react";
import CategoryLayout from "../layouts/CategoryLayout";
import "./../styles/modern-category-grid.css";
import { HashLoader } from "react-spinners";
import ToastNotification, { showToast } from "../components/toasts/ToastNotification";
import { getProductsByType } from "../api/product.api";
import ScrollToTopButton from "../components/scroll-to-top/scroll-to-top-button";
import ModernCategoryGrid from "../components/category/ModernCategoryGrid";
import Pagination from "../components/pagination/Pagination";

const PAGE_LIMIT = 6;
const DEFAULT_FILTERS = {
  search: "",
  minPrice: "",
  maxPrice: "",
  minRating: "",
  sort: "newest",
};

export const TopUpCategory = () => {
  const [loading, setLoading] = useState(false);
  const [packages, setPackages] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalProducts, setTotalProducts] = useState(0);
  const [filters, setFilters] = useState(DEFAULT_FILTERS);
  const [appliedFilters, setAppliedFilters] = useState(DEFAULT_FILTERS);

  const fetchTopUpPackages = useCallback(async () => {
    try {
      setLoading(true);
      const res = await getProductsByType("topup_package", PAGE_LIMIT, currentPage, appliedFilters);

      if (res.success) {
        setPackages(res.data.products || []);
        setTotalPages(Number(res.data.totalPages || 1));
        setTotalProducts(Number(res.data.total || 0));
      }
    } catch (error) {
      showToast(error.message, "error");
    } finally {
      setLoading(false);
    }
  }, [currentPage, appliedFilters]);

  useEffect(() => {
    fetchTopUpPackages();
  }, [fetchTopUpPackages]);

  const handlePageChange = (page) => {
    if (page === currentPage) return;
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  const handleApplyFilters = () => {
    setCurrentPage(1);
    setAppliedFilters({ ...filters });
  };

  const handleResetFilters = () => {
    setCurrentPage(1);
    setFilters(DEFAULT_FILTERS);
    setAppliedFilters(DEFAULT_FILTERS);
  };

  return (
    <CategoryLayout title={"Danh mục sản phẩm"}>
      <ToastNotification />
      <ScrollToTopButton />

      {loading ? (
        <div style={{ height: "100vh" }} className="loader-container">
          <HashLoader color="var(--hash-loader-color)" />
        </div>
      ) : (
        <>
          <ModernCategoryGrid
            title="Nạp Game Mobile"
            subtitle="Chọn gói nạp nhanh với mức giá cạnh tranh và giao dịch bảo hành rõ ràng."
            items={packages}
            totalItems={totalProducts}
            type="topup"
            filters={filters}
            onFilterChange={handleFilterChange}
            onApplyFilters={handleApplyFilters}
            onResetFilters={handleResetFilters}
          />

          {totalPages > 1 && (
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          )}
        </>
      )}
    </CategoryLayout>
  );
};
